import { saveMarketMatch } from "@/api/matches";
import { resetMarketMatch } from "@/api/matches/resetMarketMatch";
import { useMutation } from "@tanstack/react-query";

export const useSaveMarketMatch = () => {
  return useMutation({
    mutationFn: saveMarketMatch,
  });
};

export const useResetMarketMatch = () => {
  return useMutation({
    mutationFn: resetMarketMatch,
  });
};
